// extracted by mini-css-extract-plugin
export default {"textFieldRoot":"footer__textFieldRoot___809ie","sendMessageSection":"footer__sendMessageSection___3yEiC","sendButtonRoot":"footer__sendButtonRoot___8Gs4F"};